export const blockIconsUiactionsChevronRightNew = (
	<span className='material-symbols-outlined'>chevron_right</span>
);
